module.exports = __webpack_public_path__ + "static/media/fishers_bjj_boxing_logo.6d40234f.png";